// apk封装路由模式
// import { createRouter, createWebHashHistory } from 'vue-router'
// web前端历史路由模式
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import SearchResults from '../views/SearchResults.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/search',
    name: 'SearchResults',
    component: SearchResults,
    meta: { displayName: 'SearchResults', title: '', }
  },
  {
    path: '/Edit',
    name: 'Edit',
    component: () => import('../views/Edit.vue'),
    meta: { displayName: '笔记列表', title: '', }
  },
  { 
    path: '/notepad/:id',
    name: 'NotepadEdit',
    component: () => import('../views/Edit.vue'), 
    meta: { displayName: '笔记编辑', title: '', }
  },
  {
    path: '/airport',
    name: 'airport',
    component: () => import('../views/airport.vue'),
    meta: { displayName: '微盘快传', title: '', }
  },
  {
      path: '/login',
      name: 'login',
      component: () => import('../views/login.vue'),
      meta: { displayName: '登录', title: '登录以及注册', }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/register.vue'),
      meta: { displayName: '注册', title: '登录以及注册', }
    },
    {
      path: '/generate',
      name: 'generate',
      component: () => import('../views/generate.vue'),
      meta: { displayName: '管理', title: '管理员生成账号', }
    },
    {
      path: '/AdminLogin',
      name: 'AdminLogin',
      component: () => import('../views/AdminLogin.vue'),
      meta: { displayName: '管理登录', title: '管理员登录', }
    },
    {
      path: '/Recycle',
      name: 'Recycle',
      component: () => import('../views/Recycle.vue'),
      meta: { displayName: '回收站', title: '回收站', }
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('../views/download.vue'),
      meta: { displayName: '下载', title: '', }
    },
    {
      path: '/share/:token',
      name: 'share',
      component: () => import('../views/share.vue'),
      meta: { displayName: '分享', title: '', }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('../components/feedback.vue'),
      meta: { displayName: '反馈', title: '', }
    },
    {
      path: '/Payment',
      name: 'Payment',
      component: () => import('../views/Payment.vue'),
      meta: { displayName: '支付', title: '', }
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('../views/setting.vue'),
      meta: { displayName: '设置', title: '', }
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 确保在 router 实例化之后使用 router.beforeEach
router.beforeEach((to, from, next) => {
  const defaultTitle = '提醒本';
  const pageTitle = to.meta.title || to.meta.displayName || defaultTitle;
  document.title = pageTitle;
  next();
});

export default router